import { useQuery } from "react-query";
import { getCategories } from "../api";
import { API_KEY_GET_CATEGORIES } from "../helpers";

export const useGetCategories = () => {
  return useQuery(API_KEY_GET_CATEGORIES, () => getCategories());
};
